import React, {Component} from 'react';
import {Tooltip} from "antd";

class ArrayGroup extends Component {

    render() {
        let {text, exp, join, style} = this.props;
        let result = [];
        if(text && exp){
            result = text.map(function (item){
                let res = null;
                return eval(`res = ${exp}`);
            })
        }
        return (
            <div style={style} title={result.join(join)}>{result.join(join)}
                {/*<Tooltip placement="topLeft" title={result.join(join)}>{result.join(join)}</Tooltip>*/}
            </div>
        );
    }
}

export default ArrayGroup;
